import React from "react";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import PageHero from "@/components/PageHero";
import ServiceIntro from "@/components/service/ServiceIntro";
import ServiceCards from "@/components/service/ServiceCards";
import ServiceQuoteSection from "@/components/service/ServiceQuoteSection";
import OtherServices from "@/components/service/OtherServices";
import CtaBand from "@/components/CtaBand";
import RoofingQuoteForm from "./sections/RoofingQuoteForm";
import { House, Layers, Sparkles, Wind, Droplets, Flame, BrickWall, Wrench } from "lucide-react";
const subServices = [{
  title: "New Roofs",
  description: "Complete pitched and tile roof installations in Southampton, using premium slates and tiles built to protect your home for decades.",
  icon: House,
  to: "/NewRoofsPage"
}, {
  title: "Flat Roofs",
  description: "Durable flat roofing solutions for Southampton extensions, garages, and dormers, including EPDM rubber, GRP fibreglass, and high-performance felt.",
  icon: Layers,
  to: "/FlatRoofsPage"
}, {
  title: "Roof Cleaning",
  description: "Professional moss removal, gentle biocidal treatments, and roof cleaning across Southampton to restore kerb appeal and prevent blocked drainage.",
  icon: Sparkles,
  to: "/RoofCleaningPage"
}, {
  title: "Fascias & Soffits",
  description: "uPVC fascia and ventilated soffit installations to shield timber rafters and maintain clean roofline ventilation across Southampton.",
  icon: Wind,
  to: "/FasciasSoffitsPage"
}, {
  title: "Guttering",
  description: "High-capacity uPVC guttering, downpipes, clearances, and watertight repairs designed for heavy South Coast rainfall.",
  icon: Droplets,
  to: "/GutteringPage"
}, {
  title: "Chimneys",
  description: "Expert chimney repairs, repointing, lead flashing, and cowl installations across Southampton to keep your chimney stack safe and watertight.",
  icon: Flame,
  to: "/ChimneysPage"
}, {
  title: "Lead Work",
  description: "Specialist lead flashings, chimney aprons, valleys, and soakers crafted to guarantee watertight roof junctions.",
  icon: Wrench,
  to: "/LeadWorkPage"
}, {
  title: "Repointing",
  description: "Precision mortar repointing for brickwork, parapets, and gable walls, preventing damp and strengthening residential structures throughout Southampton.",
  icon: BrickWall,
  to: "/RePointingServicesPage"
}];
export default function RoofingServicesPage() {
  return <div className="min-h-screen bg-background text-foreground flex flex-col">
      <Header />

      <main className="flex-1">
        <PageHero breadcrumbLabel="Roofing Services" breadcrumbParent={{
        label: "Services",
        to: "/ServicesHubPage"
      }} eyebrow="OUR SERVICES" title="Roofing Services in Southampton" intro="Firststop Roofing Ltd delivers premier residential roofing services in Southampton, Hampshire & surrounding areas. From emergency roof repairs and timber inspections to full slate and tile replacements, our team protects your home with lasting craftsmanship." imageSrc="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662274/img/uk_residential_slate_roof.png" imageAlt="Slate tile roofing installation completed in Southampton by Firststop Roofing Ltd" actions />

        <ServiceIntro eyebrow="EXPERT OVERVIEW" heading="Trusted Roofing Services in Southampton" paragraphs={[<p key="p1">
              Looking for a dependable roofer in Southampton? Firststop Roofing Ltd provides comprehensive roofing services across Southampton, Hampshire &amp; surrounding areas. Whether you need a brand-new pitched roof, urgent leak repairs, flat roof replacement, or chimney care, owner Matt and our experienced tradespeople deliver reliable, high-specification workmanship.
            </p>, <p key="p2">
              Every project is managed with structural precision, from comprehensive initial roof inspections and timber framework checks to weather-sealed slate and tile fixing. We proudly serve homeowners across Southampton, Eastleigh, Totton, Shirley, Bitterne, Hedge End, Romsey, and all nearby Hampshire communities.
            </p>]} benefits={["Hands-on roofing experience on Southampton homes led by Matt", "British standard slates, tiles, and high-performance weatherproofing", "Transparent pricing with honest advice and free no-obligation quotes"]} imageSrc="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662274/img/uk_residential_slate_roof.png" imageAlt="High-resolution UK residential slate roof in Southampton" cta />

        <ServiceCards eyebrow="SPECIALIST DISCIPLINES" heading="Roofing Services We Provide in Southampton" intro="Comprehensive roofing solutions tailored to protect and enhance your Southampton property with expert craftsmanship." items={subServices} columns={3} />

        <ServiceQuoteSection id="get-a-free-quote" eyebrow="GET A FREE QUOTE" heading="Get a Free Roofing Quote in Southampton" intro="Tell us about your roofing project and Matt will get back to you with friendly advice and a free, no-obligation quote for your Southampton property." serviceName="Roofing Services in Southampton">
          <RoofingQuoteForm />
        </ServiceQuoteSection>

        <OtherServices currentKey="roofing-services" count={4} />

        <CtaBand />
      </main>

      <Footer />
    </div>;
}